import queryString, {} from 'query-string';
const queryStringOptions = {
    // languages=de&languages=en
    arrayFormat: 'none',
    sort: false,
};
function stringifySearch(searchObj) {
    const query = queryString.stringify(searchObj, queryStringOptions);
    return query ? `?${query}` : '';
}
function parseSearch(searchStr) {
    const parsed = queryString.parse(searchStr, queryStringOptions);
    // query-string returns a null-prototype object; this makes it a plain object
    return { ...parsed };
}
export const searchParser = {
    stringifySearch,
    parseSearch,
};
//# sourceMappingURL=searchParser.js.map